<template>
    <client-page class="app--main">
        <!-- S: sub-visual -->
        <section class="sub-visual">
            <v-container>
                <div class="tit-wrap mb-24 mb-md-50 mb-lg-0">
                    <v-img class="tit-wrap__img" src="/images/common/tit-img.png"></v-img>
                    <h2 class="tit tit--xl">
                        Company
                    </h2>
                </div>
            </v-container>
            <v-img class="sub-visual__img" src="/images/sub/company/sub-visual-company.jpg"></v-img>
            <sub-tab page="회사소개" :tabActive="2"></sub-tab>
        </section>
        <!-- E: sub-visual -->

        <!-- S: history -->
        <section class="sub-section sub-section--history">
            <v-container class="page-text">
                <v-row no-gutters class="mb-50 mb-md-100">
                    <v-col cols="12" xl="6">
                        <div class="pr-xl-24">
                            <v-card flat max-width="608" class="mb-24" data-aos="fade-left">
                                <v-img src="/images/sub/company/history/history01.jpg"></v-img>
                            </v-card>
                        </div>
                    </v-col>

                    <v-col xl="6">
                        <div class="history-list history-list--top">
                            <v-row class="row--large">
                                <v-col cols="12">
                                    <div class="history-list__li d-flex" align="center">
                                        <v-img max-width="100" class="mx-24 d-none d-md-inline-block" src="/images/sub/company/history/line.png"></v-img>
                                        <span class="font-weight-medium w-44px w-md-60px mr-8" align="left">
                                            1997
                                        </span>
                                        <span class="grey--text">
                                            오뚜기 CFC 설립
                                        </span>
                                    </div>
                                </v-col>

                                <v-col cols="12">
                                    <div class="history-list__li d-flex" align="center">
                                        <v-img max-width="100" class="mx-24 d-none d-md-inline-block" src="/images/sub/company/history/line.png"></v-img>
                                        <span class="font-weight-medium w-44px w-md-60px mr-8" align="left">
                                            1998
                                        </span>
                                        <span class="grey--text">
                                            오뚜기 에덴 인수합병
                                        </span>
                                    </div>
                                </v-col>

                                <v-col cols="12">
                                    <div class="history-list__li d-flex" align="center">
                                        <v-img max-width="100" class="mx-24 d-none d-md-inline-block" src="/images/sub/company/history/line.png"></v-img>
                                        <span class="font-weight-medium w-44px w-md-60px mr-8" align="left">
                                            1999
                                        </span>
                                        <span class="grey--text font-pretendard">
                                            (주)하림 계약체결
                                        </span>
                                    </div>
                                </v-col>

                                <v-col cols="12">
                                    <div class="history-list__li d-flex" align="center">
                                        <v-img max-width="100" class="mx-24 d-none d-md-inline-block" src="/images/sub/company/history/line.png"></v-img>
                                        <span class="font-weight-medium w-44px w-md-60px mr-8" align="left">
                                            2000
                                        </span>
                                        <span class="grey--text font-pretendard">
                                            (주)멕시칸 계약체결
                                        </span>
                                    </div>
                                </v-col>

                                <v-col cols="12">
                                    <div class="history-list__li d-flex" align="center">
                                        <v-img max-width="100" class="mx-24 d-none d-md-inline-block" src="/images/sub/company/history/line.png"></v-img>
                                        <span class="font-weight-medium w-44px w-md-60px mr-8" align="left">
                                            2001
                                        </span>
                                        <span class="grey--text">
                                            OUTBACK STEAK HOUSE 전지점 계약체결
                                        </span>
                                    </div>
                                </v-col>

                                <v-col cols="12">
                                    <div class="history-list__li d-flex" align="center">
                                        <v-img max-width="100" class="mx-24 d-none d-md-inline-block" src="/images/sub/company/history/line.png"></v-img>
                                        <span class="font-weight-medium w-44px w-md-60px mr-8" align="left">
                                            2002
                                        </span>
                                        <span class="grey--text">
                                            BBQ 본사 소스원료 납품계약체결
                                        </span>
                                    </div>
                                </v-col>

                                <v-col cols="12">
                                    <div class="history-list__li d-flex" align="center">
                                        <v-img max-width="100" class="mx-24 d-none d-md-inline-block" src="/images/sub/company/history/line.png"></v-img>
                                        <span class="font-weight-medium w-44px w-md-60px mr-8" align="left">
                                            2004
                                        </span>
                                        <span class="grey--text">
                                            버거킹 전지점 납품계약체결
                                        </span>
                                    </div>
                                </v-col>

                                <v-col cols="12">
                                    <div class="history-list__li d-flex" align="center">
                                        <v-img max-width="100" class="mx-24 d-none d-md-inline-block" src="/images/sub/company/history/line.png"></v-img>
                                        <span class="font-weight-medium w-44px w-md-60px mr-8" align="left">
                                            2005
                                        </span>
                                        <span class="grey--text">
                                            미스터 피자 납품계약체결
                                        </span>
                                    </div>
                                </v-col>

                                <v-col cols="12">
                                    <div class="history-list__li d-flex" align="center">
                                        <v-img max-width="100" class="mx-24 d-none d-md-inline-block" src="/images/sub/company/history/line.png"></v-img>
                                        <span class="font-weight-medium w-44px w-md-60px mr-8" align="left">
                                            2006
                                        </span>
                                        <span class="grey--text font-pretendard">
                                            &quot;(주)모두에프엔티&quot;로 상호변경
                                        </span>
                                    </div>
                                </v-col>

                                <v-col cols="12">
                                    <div class="history-list__li d-flex" align="center">
                                        <v-img max-width="100" class="mx-24 d-none d-md-inline-block" src="/images/sub/company/history/line.png"></v-img>
                                        <span class="font-weight-medium w-44px w-md-60px mr-8" align="left">
                                            2008
                                        </span>
                                        <span class="grey--text">
                                            해피궁 서울/경기북부지사 납품계약체결, 연매출 100억달성
                                        </span>
                                    </div>
                                </v-col>

                                <v-col cols="12">
                                    <div class="history-list__li d-flex" align="center">
                                        <v-img max-width="100" class="mx-24 d-none d-md-inline-block" src="/images/sub/company/history/line.png"></v-img>
                                        <span class="font-weight-medium w-44px w-md-60px mr-8" align="left">
                                            2009
                                        </span>
                                        <span class="grey--text font-pretendard">
                                            롯데리아, 본스, CJ프러시웨이(CGV), 시아스 납품계약체결
                                        </span>
                                    </div>
                                </v-col>
                            </v-row>
                            <v-img max-width="24" class="center-line d-none d-md-block" src="/images/sub/company/history/center-line01.png"></v-img>
                        </div>
                    </v-col>
                </v-row>

                <!-- S: bottom mobile -->
                <v-row no-gutters class="d-md-none">
                    <v-col cols="12">
                        <v-card flat max-width="608" class="mb-24 mb-md-0" data-aos="fade-left">
                            <v-img  src="/images/sub/company/history/history02.jpg"></v-img>
                        </v-card>
                    </v-col>

                    <v-col>
                        <div class="history-list history-list--top">
                            <v-row class="row--large">
                                <v-col cols="12">
                                    <div class="history-list__li d-flex align-center">
                                        <v-img max-width="100" class="mx-24 d-none d-md-inline-block" src="/images/sub/company/history/line.png"></v-img>
                                        <span class="font-weight-medium w-44px w-md-60px mr-8" align="left">
                                            2013
                                        </span>
                                        <span class="grey--text">
                                            스시로 전지점 물류 계약체결
                                        </span>
                                    </div>
                                </v-col>

                                <v-col cols="12">
                                    <div class="history-list__li d-flex" align="center">
                                        <v-img max-width="100" class="mx-24 d-none d-md-inline-block" src="/images/sub/company/history/line.png"></v-img>
                                        <span class="font-weight-medium w-44px w-md-60px mr-8" align="left">
                                            2014
                                        </span>
                                        <span class="grey--text">
                                            도니버거, 효소원, 물류계약체결
                                        </span>
                                    </div>
                                </v-col>

                                <v-col cols="12">
                                    <div class="history-list__li d-flex" align="center">
                                        <v-img max-width="100" class="mx-24 d-none d-md-inline-block" src="/images/sub/company/history/line.png"></v-img>
                                        <span class="font-weight-medium w-44px w-md-60px mr-8" align="left">
                                            2015
                                        </span>
                                        <span class="grey--text">
                                            육대장 계약체결
                                        </span>
                                    </div>
                                </v-col>

                                <v-col cols="12">
                                    <div class="history-list__li d-flex" align="center">
                                        <v-img max-width="100" class="mx-24 d-none d-md-inline-block" src="/images/sub/company/history/line.png"></v-img>
                                        <span class="font-weight-medium w-44px w-md-60px mr-8" align="left">
                                            2016
                                        </span>
                                        <span class="grey--text">
                                            서브원 물품공급
                                        </span>
                                    </div>
                                </v-col>

                                <v-col cols="12">
                                    <div class="history-list__li d-flex" align="center">
                                        <v-img max-width="100" class="mx-24 d-none d-md-inline-block" src="/images/sub/company/history/line.png"></v-img>
                                        <span class="font-weight-medium w-44px w-md-60px mr-8" align="left">
                                            2017
                                        </span>
                                        <span class="grey--text">
                                            베베쿡 계약체결
                                        </span>
                                    </div>
                                </v-col>

                                <v-col cols="12">
                                    <div class="history-list__li d-flex" align="center">
                                        <v-img max-width="100" class="mx-24 d-none d-md-inline-block" src="/images/sub/company/history/line.png"></v-img>
                                        <span class="font-weight-medium w-44px w-md-60px mr-8" align="left">
                                            2018
                                        </span>
                                        <span class="grey--text">
                                            쿠우쿠우 매장 11곳 납품계약체결
                                        </span>
                                    </div>
                                </v-col>

                                <v-col cols="12">
                                    <div class="history-list__li d-flex" align="center">
                                        <v-img max-width="100" class="mx-24 d-none d-md-inline-block" src="/images/sub/company/history/line.png"></v-img>
                                        <span class="font-weight-medium w-44px w-md-60px mr-8" align="left">
                                            2019
                                        </span>
                                        <span class="grey--text">
                                            오늘애 김밥, 달테이블, 영동 씨푸드 납품계약체결
                                        </span>
                                    </div>
                                </v-col>

                                <v-col cols="12">
                                    <div class="history-list__li d-flex" align="center">
                                        <v-img max-width="100" class="mx-24 d-none d-md-inline-block" src="/images/sub/company/history/line.png"></v-img>
                                        <span class="font-weight-medium w-44px w-md-60px mr-8" align="left">
                                            2020
                                        </span>
                                        <span class="grey--text">
                                            마키노차야 뷔페, 텐미닛 쿡 계약체결
                                        </span>
                                    </div>
                                </v-col>

                                <v-col cols="12">
                                    <div class="history-list__li d-flex" align="center">
                                        <v-img max-width="100" class="mx-24 d-none d-md-inline-block" src="/images/sub/company/history/line.png"></v-img>
                                        <span class="font-weight-medium w-44px w-md-60px mr-8" align="left">
                                            2021
                                        </span>
                                        <span class="grey--text">
                                            정돈 돈까스 납품계약체결
                                        </span>
                                    </div>
                                </v-col>

                                <v-col cols="12">
                                    <div class="history-list__li d-flex" align="center">
                                        <v-img max-width="100" class="mx-24 d-none d-md-inline-block" src="/images/sub/company/history/line.png"></v-img>
                                        <span class="font-weight-medium w-44px w-md-60px mr-8" align="left">
                                            2022
                                        </span>
                                        <span class="grey--text">
                                            교산동에서 창우동으로 회사 장소 이전
                                        </span>
                                    </div>
                                </v-col>

                                <v-col cols="12">
                                    <div class="history-list__li d-flex" align="center">
                                        <v-img max-width="100" class="mx-24 d-none d-md-inline-block" src="/images/sub/company/history/line.png"></v-img>
                                        <span class="font-weight-medium w-44px w-md-60px mr-8" align="left">
                                            2023
                                        </span>
                                        <span class="grey--text">
                                            카페프루츠 수주계약, 유로베이크 대리점 계약 및 베이커리&카페 사업 확장 예정
                                        </span>
                                    </div>
                                </v-col>
                            </v-row>
                            <v-img max-width="24" class="center-line d-none d-md-block" src="/images/sub/company/history/center-line01.png"></v-img>
                        </div>
                    </v-col>
                </v-row>
                <!-- E: bottom mobile -->

                <!-- S: bottom tablet pc -->
                <v-row no-gutters class="d-none d-md-flex">
                    <v-col cols="12" xl="6">
                        <div class="history-list history-list--bottom">
                            <v-row class="row--large">
                                <v-col cols="12">
                                    <div class="history-list__li d-flex" align="center">
                                        <span class="grey--text">
                                            스시로 전지점 물류 계약체결
                                        </span>
                                        <span class="font-weight-medium w-44px w-md-60px ml-8" align="right">
                                            2013
                                        </span>
                                        <v-img width="100" max-width="100" class="mx-24 d-none d-md-inline-block" aspect-ratio="100/30" src="/images/sub/company/history/line.png"></v-img>
                                    </div>
                                </v-col>

                                <v-col cols="12">
                                    <div class="history-list__li d-flex" align="center">
                                        <span class="grey--text">
                                            도니버거, 효소원, 물류계약체결
                                        </span>
                                        <span class="font-weight-medium w-44px w-md-60px ml-8" align="right">
                                            2014
                                        </span>
                                        <v-img width="100" max-width="100" class="mx-24 d-none d-md-inline-block" aspect-ratio="100/30" src="/images/sub/company/history/line.png"></v-img>
                                    </div>
                                </v-col>

                                <v-col cols="12">
                                    <div class="history-list__li d-flex" align="center">
                                        <span class="grey--text">
                                            육대장 계약체결
                                        </span>
                                        <span class="font-weight-medium w-44px w-md-60px ml-8" align="right">
                                            2015
                                        </span>
                                        <v-img width="100" max-width="100" class="mx-24 d-none d-md-inline-block" aspect-ratio="100/30" src="/images/sub/company/history/line.png"></v-img>
                                    </div>
                                </v-col>

                                <v-col cols="12">
                                    <div class="history-list__li d-flex" align="center">
                                        <span class="grey--text">
                                            서브원 물품공급
                                        </span>
                                        <span class="font-weight-medium w-44px w-md-60px ml-8" align="right">
                                            2016
                                        </span>
                                        <v-img width="100" max-width="100" class="mx-24 d-none d-md-inline-block" aspect-ratio="100/30" src="/images/sub/company/history/line.png"></v-img>
                                    </div>
                                </v-col>

                                <v-col cols="12">
                                    <div class="history-list__li d-flex" align="center">
                                        <span class="grey--text">
                                            베베쿡 계약체결
                                        </span>
                                        <span class="font-weight-medium w-44px w-md-60px ml-8" align="right">
                                            2017
                                        </span>
                                        <v-img width="100" max-width="100" class="mx-24 d-none d-md-inline-block" aspect-ratio="100/30" src="/images/sub/company/history/line.png"></v-img>
                                    </div>
                                </v-col>

                                <v-col cols="12">
                                    <div class="history-list__li d-flex" align="center">
                                        <span class="grey--text">
                                            쿠우쿠우 매장 11곳 납품계약체결
                                        </span>
                                        <span class="font-weight-medium w-44px w-md-60px ml-8" align="right">
                                            2018
                                        </span>
                                        <v-img width="100" max-width="100" class="mx-24 d-none d-md-inline-block" aspect-ratio="100/30" src="/images/sub/company/history/line.png"></v-img>
                                    </div>
                                </v-col>

                                <v-col cols="12">
                                    <div class="history-list__li d-flex" align="center">
                                        <span class="grey--text">
                                            오늘애 김밥, 달테이블, 영동 씨푸드 납품계약체결
                                        </span>
                                        <span class="font-weight-medium w-44px w-md-60px ml-8" align="right">
                                            2019
                                        </span>
                                        <v-img width="100" max-width="100" class="mx-24 d-none d-md-inline-block" aspect-ratio="100/30"  src="/images/sub/company/history/line.png"></v-img>
                                    </div>
                                </v-col>

                                <v-col cols="12">
                                    <div class="history-list__li d-flex" align="center">
                                        <span class="grey--text">
                                            마키노차야 뷔페, 텐미닛 쿡 계약체결
                                        </span>
                                        <span class="font-weight-medium w-44px w-md-60px ml-8" align="right">
                                            2020
                                        </span>
                                        <v-img width="100" max-width="100" class="mx-24 d-none d-md-inline-block" aspect-ratio="100/30"  src="/images/sub/company/history/line.png"></v-img>
                                    </div>
                                </v-col>

                                <v-col cols="12">
                                    <div class="history-list__li d-flex" align="center">
                                        <span class="grey--text">
                                            정돈 돈까스 납품계약체결
                                        </span>
                                        <span class="font-weight-medium w-44px w-md-60px ml-8" align="right">
                                            2021
                                        </span>
                                        <v-img width="100" max-width="100" class="mx-24 d-none d-md-inline-block" aspect-ratio="100/30"  src="/images/sub/company/history/line.png"></v-img>
                                    </div>
                                </v-col>

                                <v-col cols="12">
                                    <div class="history-list__li d-flex" align="center">
                                        <span class="grey--text">
                                            교산동에서 창우동으로 회사 장소 이전
                                        </span>
                                        <span class="font-weight-medium w-44px w-md-60px ml-8" align="right">
                                            2022
                                        </span>
                                        <v-img width="100" max-width="100" class="mx-24 d-none d-md-inline-block" aspect-ratio="100/30"  src="/images/sub/company/history/line.png"></v-img>
                                    </div>
                                </v-col>

                                <v-col cols="12">
                                    <div class="history-list__li d-flex" align="center">
                                        <span class="grey--text">
                                            카페프루츠 수주계약, 유로베이크 대리점 계약 및 베이커리 &카페 <br class="d-none d-md-block" />
                                            사업 확장 예정
                                        </span>
                                        <span class="font-weight-medium w-44px w-md-60px ml-8" align="right">
                                            2023
                                        </span>
                                        <v-img width="100" max-width="100" class="mx-24 d-none d-md-inline-block" aspect-ratio="100/30"  src="/images/sub/company/history/line.png"></v-img>
                                    </div>
                                </v-col>
                            </v-row>
                            <v-img max-width="24" class="d-none d-md-block center-line" src="/images/sub/company/history/center-line02.png"></v-img>
                        </div>
                    </v-col>

                    <v-col cols="12" xl="6" align="right">
                        <div class="pl-xl-24">
                            <v-card flat max-width="608" class="mt-40 mt-xl-0" data-aos="fade-right">
                                <v-img  src="/images/sub/company/history/history02.jpg"></v-img>
                            </v-card>
                        </div>
                    </v-col>
                </v-row>
                <!-- S: bottom tablet pc -->
            </v-container>
        </section>
        <!-- E: history -->
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/templates/ClientPage.vue";
import SubTab from "@/components/client/sub/sub-tab.vue";
// import BoardList from "@/components/client/board/board-list.vue";
import PopupLayer from "@/components/client/popup/popup-layer.vue";
import LocaleSelect from "@/components/client/inc/locale-select.vue";
import { BOARD_YOUTUBE_CATEGORIES, BOARD_REPORT_CATEGORIES, BOARD_FORMS_CATEGORIES } from "@/assets/variables";
import Swiper from "swiper/bundle";
import IconArrowRounded from "@/components/client/icons/icon-arrow-rounded.vue";

const categoriesYoutube = Object.values(BOARD_YOUTUBE_CATEGORIES);
const categoriesReport = Object.values(BOARD_REPORT_CATEGORIES);
const categoriesForms = Object.values(BOARD_FORMS_CATEGORIES);

export default {
    components: {
        ClientPage,
        SubTab,
        // BoardList,
        PopupLayer,
        LocaleSelect,
        IconArrowRounded,
    },
    props: {
        isMain: { type: Boolean, default: true },
    },
    data: () => ({
        categoriesYoutube,
        categoriesReport,
        categoriesForms,
    }),
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            this.$nextTick(() => {
                this.Swiper = new Swiper(".products-slide .swiper-container", {
                    slidesPerView: 1,
                    spaceBetween: 120,
                    speed: 1000,
                    navigation: {
                        nextEl: ".swiper-button-next",
                        prevEl: ".swiper-button-prev",
                    },
                    breakpoints: {
                        // pc
                        768: {
                            slidesPerView: 2,
                        },
                    },
                });
            });
        },
    },
};
</script>
